export default __webpack_public_path__ + "static/media/GARDEN.f5ee31fc.png";